export default function head<T>(arr: T[]): T | undefined {
  return arr?.[0] || undefined;
}
